import { useEffect, useRef } from "react";
import { keys } from "../../../../../../common/util/Object/keys";
import { OriginKey, Post } from "../types";

const functionsToUpdateBackgroundPosts: {
    [key in OriginKey]?: (newPosts: Post[]) => void;
} = {};

export function useSyncPostsStateWithBackgroundPanel(
    originKey: OriginKey,
    posts: Post[],
    setPosts: (posts: Post[]) => void
) {
    useEffect(() => {
        // set functionsToUpdateBackgroundPosts
        functionsToUpdateBackgroundPosts[originKey] = newPosts => {
            if (newPosts.length > 0) {
                setPosts(
                    posts.map(post => {
                        const newPost = newPosts.find(
                            newPost =>
                                newPost.userId === post.userId &&
                                newPost.postNo === post.postNo
                        );
                        return newPost ?? post;
                    })
                );
            }
        };
        return () => {
            delete functionsToUpdateBackgroundPosts[originKey];
        };
    }, [originKey, posts]);

    const currentDataContainer = useRef<{
        posts: Post[];
        originKey: OriginKey;
    } | null>(null);
    currentDataContainer.current = { posts, originKey };

    useEffect(() => {
        return () => {
            // Sync data on unmount
            if (!currentDataContainer.current) {
                return;
            }
            const { posts, originKey } = currentDataContainer.current;
            keys(functionsToUpdateBackgroundPosts).forEach(key => {
                if (key === originKey) {
                    return;
                }
                functionsToUpdateBackgroundPosts[key]?.(posts);
            });
        };
    }, [currentDataContainer]);
}
